// Liste complète des codes pays
export const countryCodes = [
  { code: '+93', country: 'Afghanistan', flag: '🇦🇫' },
  { code: '+355', country: 'Albanie', flag: '🇦🇱' },
  { code: '+213', country: 'Algérie', flag: '🇩🇿' },
  { code: '+1', country: 'États-Unis', flag: '🇺🇸' },
  { code: '+376', country: 'Andorre', flag: '🇦🇩' },
  { code: '+244', country: 'Angola', flag: '🇦🇴' },
  { code: '+54', country: 'Argentine', flag: '🇦🇷' },
  { code: '+374', country: 'Arménie', flag: '🇦🇲' },
  { code: '+61', country: 'Australie', flag: '🇦🇺' },
  { code: '+43', country: 'Autriche', flag: '🇦🇹' },
  { code: '+994', country: 'Azerbaïdjan', flag: '🇦🇿' },
  { code: '+973', country: 'Bahreïn', flag: '🇧🇭' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩' },
  { code: '+375', country: 'Biélorussie', flag: '🇧🇾' },
  { code: '+32', country: 'Belgique', flag: '🇧🇪' },
  { code: '+501', country: 'Belize', flag: '🇧🇿' },
  { code: '+229', country: 'Bénin', flag: '🇧🇯' },
  { code: '+591', country: 'Bolivie', flag: '🇧🇴' },
  { code: '+387', country: 'Bosnie-Herzégovine', flag: '🇧🇦' },
  { code: '+267', country: 'Botswana', flag: '🇧🇼' },
  { code: '+55', country: 'Brésil', flag: '🇧🇷' },
  { code: '+359', country: 'Bulgarie', flag: '🇧🇬' },
  { code: '+226', country: 'Burkina Faso', flag: '🇧🇫' },
  { code: '+257', country: 'Burundi', flag: '🇧🇮' },
  { code: '+855', country: 'Cambodge', flag: '🇰🇭' },
  { code: '+237', country: 'Cameroun', flag: '🇨🇲' },
  { code: '+1', country: 'Canada', flag: '🇨🇦' },
  { code: '+238', country: 'Cap-Vert', flag: '🇨🇻' },
  { code: '+56', country: 'Chili', flag: '🇨🇱' },
  { code: '+86', country: 'Chine', flag: '🇨🇳' },
  { code: '+357', country: 'Chypre', flag: '🇨🇾' },
  { code: '+57', country: 'Colombie', flag: '🇨🇴' },
  { code: '+269', country: 'Comores', flag: '🇰🇲' },
  { code: '+242', country: 'Congo', flag: '🇨🇬' },
  { code: '+243', country: 'Congo (RDC)', flag: '🇨🇩' },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷' },
  { code: '+385', country: 'Croatie', flag: '🇭🇷' },
  { code: '+53', country: 'Cuba', flag: '🇨🇺' },
  { code: '+45', country: 'Danemark', flag: '🇩🇰' },
  { code: '+253', country: 'Djibouti', flag: '🇩🇯' },
  { code: '+593', country: 'Équateur', flag: '🇪🇨' },
  { code: '+20', country: 'Égypte', flag: '🇪🇬' },
  { code: '+503', country: 'Salvador', flag: '🇸🇻' },
  { code: '+971', country: 'Émirats arabes unis', flag: '🇦🇪' },
  { code: '+34', country: 'Espagne', flag: '🇪🇸' },
  { code: '+372', country: 'Estonie', flag: '🇪🇪' },
  { code: '+251', country: 'Éthiopie', flag: '🇪🇹' },
  { code: '+358', country: 'Finlande', flag: '🇫🇮' },
  { code: '+33', country: 'France', flag: '🇫🇷' },
  { code: '+241', country: 'Gabon', flag: '🇬🇦' },
  { code: '+220', country: 'Gambie', flag: '🇬🇲' },
  { code: '+995', country: 'Géorgie', flag: '🇬🇪' },
  { code: '+49', country: 'Allemagne', flag: '🇩🇪' },
  { code: '+233', country: 'Ghana', flag: '🇬🇭' },
  { code: '+30', country: 'Grèce', flag: '🇬🇷' },
  { code: '+502', country: 'Guatemala', flag: '🇬🇹' },
  { code: '+224', country: 'Guinée', flag: '🇬🇳' },
  { code: '+245', country: 'Guinée-Bissau', flag: '🇬🇼' },
  { code: '+592', country: 'Guyana', flag: '🇬🇾' },
  { code: '+509', country: 'Haïti', flag: '🇭🇹' },
  { code: '+504', country: 'Honduras', flag: '🇭🇳' },
  { code: '+36', country: 'Hongrie', flag: '🇭🇺' },
  { code: '+91', country: 'Inde', flag: '🇮🇳' },
  { code: '+62', country: 'Indonésie', flag: '🇮🇩' },
  { code: '+98', country: 'Iran', flag: '🇮🇷' },
  { code: '+964', country: 'Irak', flag: '🇮🇶' },
  { code: '+353', country: 'Irlande', flag: '🇮🇪' },
  { code: '+354', country: 'Islande', flag: '🇮🇸' },
  { code: '+972', country: 'Israël', flag: '🇮🇱' },
  { code: '+39', country: 'Italie', flag: '🇮🇹' },
  { code: '+225', country: 'Côte d\'Ivoire', flag: '🇨🇮' },
  { code: '+81', country: 'Japon', flag: '🇯🇵' },
  { code: '+962', country: 'Jordanie', flag: '🇯🇴' },
  { code: '+7', country: 'Kazakhstan', flag: '🇰🇿' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪' },
  { code: '+996', country: 'Kirghizistan', flag: '🇰🇬' },
  { code: '+965', country: 'Koweït', flag: '🇰🇼' },
  { code: '+856', country: 'Laos', flag: '🇱🇦' },
  { code: '+371', country: 'Lettonie', flag: '🇱🇻' },
  { code: '+961', country: 'Liban', flag: '🇱🇧' },
  { code: '+266', country: 'Lesotho', flag: '🇱🇸' },
  { code: '+231', country: 'Liberia', flag: '🇱🇷' },
  { code: '+218', country: 'Libye', flag: '🇱🇾' },
  { code: '+423', country: 'Liechtenstein', flag: '🇱🇮' },
  { code: '+370', country: 'Lituanie', flag: '🇱🇹' },
  { code: '+352', country: 'Luxembourg', flag: '🇱🇺' },
  { code: '+389', country: 'Macédoine du Nord', flag: '🇲🇰' },
  { code: '+261', country: 'Madagascar', flag: '🇲🇬' },
  { code: '+265', country: 'Malawi', flag: '🇲🇼' },
  { code: '+60', country: 'Malaisie', flag: '🇲🇾' },
  { code: '+960', country: 'Maldives', flag: '🇲🇻' },
  { code: '+223', country: 'Mali', flag: '🇲🇱' },
  { code: '+356', country: 'Malte', flag: '🇲🇹' },
  { code: '+212', country: 'Maroc', flag: '🇲🇦' },
  { code: '+230', country: 'Maurice', flag: '🇲🇺' },
  { code: '+222', country: 'Mauritanie', flag: '🇲🇷' },
  { code: '+52', country: 'Mexique', flag: '🇲🇽' },
  { code: '+373', country: 'Moldavie', flag: '🇲🇩' },
  { code: '+377', country: 'Monaco', flag: '🇲🇨' },
  { code: '+976', country: 'Mongolie', flag: '🇲🇳' },
  { code: '+382', country: 'Monténégro', flag: '🇲🇪' },
  { code: '+258', country: 'Mozambique', flag: '🇲🇿' },
  { code: '+95', country: 'Myanmar', flag: '🇲🇲' },
  { code: '+264', country: 'Namibie', flag: '🇳🇦' },
  { code: '+977', country: 'Népal', flag: '🇳🇵' },
  { code: '+505', country: 'Nicaragua', flag: '🇳🇮' },
  { code: '+227', country: 'Niger', flag: '🇳🇪' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬' },
  { code: '+47', country: 'Norvège', flag: '🇳🇴' },
  { code: '+64', country: 'Nouvelle-Zélande', flag: '🇳🇿' },
  { code: '+968', country: 'Oman', flag: '🇴🇲' },
  { code: '+256', country: 'Ouganda', flag: '🇺🇬' },
  { code: '+998', country: 'Ouzbékistan', flag: '🇺🇿' },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰' },
  { code: '+507', country: 'Panama', flag: '🇵🇦' },
  { code: '+595', country: 'Paraguay', flag: '🇵🇾' },
  { code: '+31', country: 'Pays-Bas', flag: '🇳🇱' },
  { code: '+51', country: 'Pérou', flag: '🇵🇪' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭' },
  { code: '+48', country: 'Pologne', flag: '🇵🇱' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦' },
  { code: '+40', country: 'Roumanie', flag: '🇷🇴' },
  { code: '+44', country: 'Royaume-Uni', flag: '🇬🇧' },
  { code: '+7', country: 'Russie', flag: '🇷🇺' },
  { code: '+250', country: 'Rwanda', flag: '🇷🇼' },
  { code: '+966', country: 'Arabie saoudite', flag: '🇸🇦' },
  { code: '+221', country: 'Sénégal', flag: '🇸🇳' },
  { code: '+381', country: 'Serbie', flag: '🇷🇸' },
  { code: '+248', country: 'Seychelles', flag: '🇸🇨' },
  { code: '+65', country: 'Singapour', flag: '🇸🇬' },
  { code: '+421', country: 'Slovaquie', flag: '🇸🇰' },
  { code: '+386', country: 'Slovénie', flag: '🇸🇮' },
  { code: '+252', country: 'Somalie', flag: '🇸🇴' },
  { code: '+249', country: 'Soudan', flag: '🇸🇩' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰' },
  { code: '+46', country: 'Suède', flag: '🇸🇪' },
  { code: '+41', country: 'Suisse', flag: '🇨🇭' },
  { code: '+597', country: 'Suriname', flag: '🇸🇷' },
  { code: '+963', country: 'Syrie', flag: '🇸🇾' },
  { code: '+992', country: 'Tadjikistan', flag: '🇹🇯' },
  { code: '+255', country: 'Tanzanie', flag: '🇹🇿' },
  { code: '+235', country: 'Tchad', flag: '🇹🇩' },
  { code: '+420', country: 'République tchèque', flag: '🇨🇿' },
  { code: '+66', country: 'Thaïlande', flag: '🇹🇭' },
  { code: '+228', country: 'Togo', flag: '🇹🇬' },
  { code: '+216', country: 'Tunisie', flag: '🇹🇳' },
  { code: '+993', country: 'Turkménistan', flag: '🇹🇲' },
  { code: '+90', country: 'Turquie', flag: '🇹🇷' },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦' },
  { code: '+598', country: 'Uruguay', flag: '🇺🇾' },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪' },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳' },
  { code: '+967', country: 'Yémen', flag: '🇾🇪' },
  { code: '+260', country: 'Zambie', flag: '🇿🇲' },
  { code: '+263', country: 'Zimbabwe', flag: '🇿🇼' }
].sort((a, b) => a.country.localeCompare(b.country));

// Design System 2025 - Couleurs modernes
export const THEME_COLORS = {
  // Couleurs principales avec dégradés
  primary: {
    main: '#6366F1', // Indigo moderne
    light: '#8B5FF8',
    dark: '#4F46E5',
    gradient: 'linear-gradient(135deg, #6366F1 0%, #8B5FF8 100%)'
  },
  secondary: {
    main: '#0EA5E9', // Sky blue moderne
    light: '#38BDF8',
    dark: '#0284C7',
    gradient: 'linear-gradient(135deg, #0EA5E9 0%, #38BDF8 100%)'
  },
  success: {
    main: '#10B981', // Emerald moderne
    light: '#34D399',
    dark: '#059669',
    gradient: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)'
  },
  error: {
    main: '#EF4444', // Red moderne
    light: '#F87171',
    dark: '#DC2626'
  },
  warning: {
    main: '#F59E0B', // Amber moderne
    light: '#FBBF24',
    dark: '#D97706'
  },
  // Couleurs neutres modernes
  background: {
    main: '#FAFBFC',
    paper: '#FFFFFF',
    glass: 'rgba(255, 255, 255, 0.8)',
    dark: '#F8FAFC'
  },
  text: {
    primary: '#1E293B',
    secondary: '#64748B',
    muted: '#94A3B8'
  },
  border: {
    light: '#E2E8F0',
    main: '#CBD5E1',
    dark: '#94A3B8'
  },
  // Effets modernes
  shadow: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  }
};

// Typographie moderne 2025
export const TYPOGRAPHY = {
  fontFamily: {
    primary: '"Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    secondary: '"JetBrains Mono", "SF Mono", Monaco, Inconsolata, "Roboto Mono", Consolas, "Droid Sans Mono", monospace'
  },
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px  
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem'     // 48px
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800
  }
};

// Animations et transitions modernes
export const ANIMATIONS = {
  transition: {
    fast: '0.15s ease-out',
    normal: '0.2s ease-out',
    slow: '0.3s ease-out'
  },
  spring: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};

// Configuration API
export const API_CONFIG = {
  baseURL: 'https://tc-crm.com',
  endpoints: {
    activities: '/api/activities',
    leadFilters: '/api/leads/filters',
    activityConf: '/api/activite-conf'
  }
};